import ReportsDefinition from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.ITEM_OVERVIEW_DETAILS_200.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.ITEM_OVERVIEW_DETAILS_200.isLoading;

export const getData =
  ReportsDefinition.ITEM_OVERVIEW_DETAILS_200.getDataFunction();
